import axios from 'axios';
import Vue from 'vue';
import { appConfig } from '../../config/app.config';

// append global variables used in app.
// static config. must maintain immutability during runtime. non-reactive.
Vue.use({
  install(vue, arg) {
    vue.prototype.$appConfig = arg;

    vue.prototype.$axiosRest = axios.create({
      baseURL: arg!.endpoints.rest,
      timeout: 5000,
      headers: {
        'Content-Type': 'application/json',
      }
    });
    vue.prototype.$axiosGatekeeper = axios.create({
      baseURL: arg!.endpoints.gatekeeper,
      timeout: 5000,
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }
}, appConfig);
